export { default } from './TextWithLinks'
